import {
  form_control_standard_styles_default
} from "./chunk.3IKJ6Y74.js";
import {
  form_control_styles_default
} from "./chunk.EK4QQDDG.js";
import {
  form_control_floating_styles_default
} from "./chunk.AHN6JZAS.js";
import {
  form_control_monochrome_styles_default
} from "./chunk.JUOLR3MG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o as o2
} from "./chunk.OBPYZVEK.js";
import {
  e,
  o,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/form-control/form-control.ts
var id = 0;
var FormControl = class extends s {
  constructor() {
    super(...arguments);
    this.idPrefix = this.tagName.toLowerCase();
    this.inputId = `${this.idPrefix}-${++id}`;
    this.helpTextId = `${this.idPrefix}-help-text-${id}`;
    this.labelId = `${this.idPrefix}-label-${id}`;
    this.hasSlotController = new HasSlotController(this, "label", "help-text", "before", "after", "prefix", "suffix");
    this.supportsBefore = true;
    this.supportsAfter = true;
    this.hasFocus = false;
    this.hasValue = false;
    this.variant = "primary";
    this.helpText = "";
    this.disabled = false;
    this.valid = false;
    this.invalid = false;
    this.floating = true;
    this.readonly = false;
    this.pill = true;
  }
  handleBlur() {
    this.hasFocus = false;
    emit(this, "sl-blur");
  }
  handleFocus() {
    if (this.disabled)
      return;
    this.hasFocus = true;
    emit(this, "sl-focus");
  }
  handleValueChange() {
    this.hasValue = !!this.value;
  }
  handleValidChange() {
    if (this.valid) {
      this.invalid = false;
    }
  }
  handleInvalidChange() {
    if (this.invalid) {
      this.valid = false;
    }
  }
  handleSlotChange() {
    function findButton(el) {
      return hasTag(el, "fadv-button") ? el : el.querySelector("fadv-button");
    }
    if (this.supportsBefore && this.hasSlotController.test("before")) {
      this.beforeElements.forEach((e2, i) => {
        const button = findButton(e2);
        if (i === 0) {
          button == null ? void 0 : button.classList.add("form-control__before-item-first");
        } else {
          button == null ? void 0 : button.classList.add("form-control__before-item");
        }
      });
    }
    if (this.supportsAfter && this.hasSlotController.test("after")) {
      this.afterElements.forEach((e2, i) => {
        const button = findButton(e2);
        if (i === this.afterElements.length - 1) {
          button == null ? void 0 : button.classList.add("form-control__after-item-last");
        } else {
          button == null ? void 0 : button.classList.add("form-control__after-item");
        }
      });
    }
  }
  getLabelledBy() {
    const labelledBy = [
      this.label || this.hasSlotController.test("label") ? this.labelId : "",
      this.helpText || this.hasSlotController.test("help-text") ? this.helpTextId : ""
    ].filter((val) => val);
    return labelledBy.join(" ") || void 0;
  }
  renderFloatingLabel() {
    if (!this.floating)
      return w;
    return this.renderLabel();
  }
  renderStandardLabel() {
    if (this.floating)
      return w;
    return this.renderLabel();
  }
  renderLabel() {
    return $`<label part="label" id=${l(this.labelId)} class="form-control__label" for=${this.inputId} title="${this.label}" aria-hidden=${this.label || this.hasSlotController.test("label") ? "false" : "true"} ><slot name="label" @slotchange=${this.handleSlotChange}>${this.label}</slot></label>`;
  }
  renderBefore() {
    if (!this.supportsBefore)
      return w;
    return $`<div class="form-control__before"><slot name="before" @slotchange=${this.handleSlotChange}></slot></div>`;
  }
  renderAfter() {
    if (!this.supportsAfter)
      return w;
    return $`<div class="form-control__after"><slot name="after" @slotchange=${this.handleSlotChange}></slot></div>`;
  }
  renderAbove() {
    return w;
  }
  renderBelow() {
    return w;
  }
  render() {
    return $`<div class=${o2({
      "form-control": true,
      "form-control--standard": !this.floating,
      "form-control--floating": this.floating,
      "form-control--has-before": this.hasSlotController.test("before"),
      "form-control--has-after": this.hasSlotController.test("after"),
      "form-control--has-label": this.label || this.hasSlotController.test("label"),
      "form-control--has-help-text": this.helpText || this.hasSlotController.test("help-text"),
      "form-control--has-prefix": this.hasSlotController.test("prefix"),
      "form-control--has-suffix": this.hasSlotController.test("suffix"),
      "form-control--pill": this.pill,
      "form-control--has-value": this.hasValue,
      "form-control--has-focus": this.hasFocus,
      "form-control--has-success": this.valid,
      "form-control--has-error": this.invalid,
      "form-control--disabled": this.disabled,
      "form-control--readonly": this.readonly,
      "form-control--primary": !this.variant || this.variant === "primary",
      "form-control--secondary": this.variant === "secondary",
      "form-control--tertiary": this.variant === "tertiary",
      "form-control--monochrome": this.variant === "monochrome"
    })} >${this.renderStandardLabel()} ${this.renderAbove()}<div class="form-control__container">${this.renderBefore()}<div class="form-control__border-exterior"><div part="base" class="form-control__border-interior">${this.renderControl()}</div></div>${this.renderAfter()}</div><div class="form-control__below">${this.renderBelow()}<div part="help-text" id=${l(this.helpTextId)} class="form-control__help-text" aria-hidden=${this.hasSlotController.test("help-text") ? "false" : "true"} ><slot name="help-text">${this.helpText}</slot></div></div></div>`;
  }
};
FormControl.styles = [form_control_styles_default, form_control_standard_styles_default, form_control_floating_styles_default, form_control_monochrome_styles_default];
__decorateClass([
  t()
], FormControl.prototype, "hasFocus", 2);
__decorateClass([
  t()
], FormControl.prototype, "hasValue", 2);
__decorateClass([
  e({ reflect: true })
], FormControl.prototype, "variant", 2);
__decorateClass([
  e()
], FormControl.prototype, "name", 2);
__decorateClass([
  e()
], FormControl.prototype, "label", 2);
__decorateClass([
  e()
], FormControl.prototype, "placeholder", 2);
__decorateClass([
  e({ attribute: "help-text" })
], FormControl.prototype, "helpText", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FormControl.prototype, "disabled", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FormControl.prototype, "valid", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FormControl.prototype, "invalid", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FormControl.prototype, "floating", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FormControl.prototype, "readonly", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FormControl.prototype, "pill", 2);
__decorateClass([
  o({ slot: "before" })
], FormControl.prototype, "beforeElements", 2);
__decorateClass([
  o({ slot: "after" })
], FormControl.prototype, "afterElements", 2);
__decorateClass([
  watch("value")
], FormControl.prototype, "handleValueChange", 1);
__decorateClass([
  watch("valid")
], FormControl.prototype, "handleValidChange", 1);
__decorateClass([
  watch("invalid")
], FormControl.prototype, "handleInvalidChange", 1);
__decorateClass([
  watch("helpText"),
  watch("label")
], FormControl.prototype, "handleSlotChange", 1);

export {
  FormControl
};
